import * as React from "react";
const SvgChevronUpRange = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 9, viewBox: "0 0 16 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 8L8 1L15 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgChevronUpRange;
